/**
 * Main App Component
 *
 * The web video uploader has been retired in favour of the HG Media iPad app,
 * so every route renders the "moved" notice. Routing, auth and the upload/history
 * components are intentionally left in the repo (unused) rather than deleted, so
 * restoring the web uploader is a one-file revert if it is ever needed again.
 */

import React from 'react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import AppMoved from './components/AppMoved/AppMoved';

// Create Material-UI theme with HomeGuard branding colors
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // Blue from logo
      light: '#42a5f5',
      dark: '#1565c0',
    },
    secondary: {
      main: '#455a64', // Gray from logo
      light: '#718792',
      dark: '#1c313a',
    },
    error: {
      main: '#d32f2f',
    },
    warning: {
      main: '#f57c00',
    },
    success: {
      main: '#388e3c',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    button: {
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          minHeight: 44, // Minimum touch target size for mobile
        },
        sizeLarge: {
          minHeight: 56,
        },
      },
    },
  },
});

/**
 * Main App Component
 */
function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppMoved />
    </ThemeProvider>
  );
}

export default App;
